interface props {
  name: string;
}

export default function PatientInfo({ name }: props) {
  return <div>{name}</div>;
}
